<template>
  <div>
    <v-row v-if="currentTime" class="white--text" style="font-size: 18px;">
      <span class="secondary--text" > NCE Timeline:  </span>
      <span class="ml-1" v-if="days"> {{ days }} Days</span>
      <span class="ml-1" v-if="hours">{{ hours | formatTime }} Hours</span>
      <span class="ml-1"> {{ minutes | formatTime }} Minutes</span>
      <span class="ml-1">{{ seconds | formatTime }} Seconds</span>
    </v-row>
    <!-- <v-row v-else>
      <v-col cols="12" md="3">
        <p class="text-center white--text"> <span>Last NCE Timeline was </span> {{this.deadline | formatDate}}  </p>
      </v-col>
    </v-row> -->
  </div>
</template>

<script>
export default {
  props: {
    deadline: {
      type: String,
      required: true
    },
    speed: {
      type: Number,
      default: 1000
    }
  },
  data () {
    return {
      currentTime: Date.parse(this.deadline) - Date.parse(new Date())
    }
  },
  mounted () {
    console.log(this.deadline)
    setTimeout(this.countdown, 1000)
  },
  computed: {
    seconds () {
      return Math.floor((this.currentTime / 1000) % 60)
    },
    minutes () {
      return Math.floor((this.currentTime / 1000 / 60) % 60)
    },
    hours () {
      return Math.floor((this.currentTime / (1000 * 60 * 60)) % 24)
    },
    days () {
      return Math.floor(this.currentTime / (1000 * 60 * 60 * 24))
    }
  },
  filters: {
    formatTime (value) {
      if (value < 10) {
        return '0' + value
      }
      return value
    }
  },
  methods: {
    countdown () {
      this.currentTime = Date.parse(this.deadline) - Date.parse(new Date())
      if (this.currentTime > 0) {
        setTimeout(this.countdown, this.speed)
      } else {
        this.currentTime = null
      }
    }
  }
}
</script>
